import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Cookie, X } from 'lucide-react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookies_accepted');
    if (!cookiesAccepted) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookies_accepted', 'true');
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookies_accepted', 'false');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-900 text-white p-4 shadow-lg">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <Cookie className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" />
          <p className="text-sm text-gray-300">
            Utilizamos cookies propias y de terceros para mejorar tu experiencia de navegación y ofrecerte contenido personalizado. 
            Puedes aceptar todas las cookies, rechazarlas o configurar tus preferencias. 
            <Link to="/cookies" className="text-blue-400 hover:underline ml-1">Más información</Link>
          </p>
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <Button
            variant="outline"
            size="sm"
            onClick={rejectCookies}
            className="border-gray-600 text-gray-300 hover:bg-gray-800"
          >
            Rechazar
          </Button>
          <Button
            size="sm"
            onClick={acceptCookies}
            className="bg-blue-600 hover:bg-blue-700"
          >
            Aceptar todo
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
